import { Container, Row, Col } from 'react-bootstrap';
import style from './style.module.scss'

export const LogoutPage = () =>{
    return(
        <Container fluid className={`d-flex justify-content-center align-items-center ${style.fullHeight}`}>
        <Row>
          <Col className="text-center">
            <i className={`bi bi-heart-fill ${style.heart}`}></i>
            <h3 className='text-primary'>Grazie per aver utilizzato Danea Transfer</h3>
          </Col>
        </Row>
      </Container>
    )
}